import { apiV2 } from '../services';
export const getTelegramBotConfig = async (subdomain) => {
    const res = await apiV2.telegramBot.getConfig({ params: { subdomain } });
    if (res.status === 200) {
        return res.body;
    }
    throw new Error(`getTelegramBotConfig failed: status=${res.status}`);
};
export const updateTelegramBotConfig = async (subdomain, config) => {
    const res = await apiV2.telegramBot.updateConfig({
        params: { subdomain },
        body: config,
    });
    if (res.status !== 204) {
        throw new Error(`updateTelegramBotConfig failed: status=${res.status}`);
    }
};
